import { render, staticRenderFns } from "./editBranch.vue?vue&type=template&id=79444f65&scoped=true&"
import script from "./editBranch.vue?vue&type=script&lang=ts&"
export * from "./editBranch.vue?vue&type=script&lang=ts&"
import style0 from "./editBranch.vue?vue&type=style&index=0&id=79444f65&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79444f65",
  null
  
)

export default component.exports